export const ADD_TO_ITINERARY_BUTTON = "ADD_TO_ITINERARY_BUTTON_PHARMACEUTIC";
export const ADD_TO_ITINERARY = "ADD_TO_ITINERARY_PHARMACEUTIC";
export const CALL_US = "CALL_US_PHARMACEUTIC";
export const IM_INTEREST = "IM_INTEREST_PHARMACEUTIC";
export const LIKE = "LIKE_PHARMACEUTIC";
export const HOW_TO_GET_THERE = "ADD_TO_ITINERARY_PHARMACEUTIC";
export const YOUTUBE_VIDEO = "YOUTUBE_VIDEO_PHARMACEUTIC";
export const VISIT_PROFILE = "VISIT_PROFILE_PHARMACEUTIC";
export const PROFILE_NAME = "Farmacias";
